module.exports = __webpack_public_path__ + "img/page22.8f94907b.png";